import { Check } from "@sparkware/app-utils";
import { SideMenuLinkConfiguration, CustomElementLink, InternalLink, ExternalLink } from "../config-data-sections/side-menu.configuration";

export function isCustomLink(config: SideMenuLinkConfiguration): config is CustomElementLink {
    return (!Check.isNullOrUndefined((config as any).isCustomElement) && (config as any).isCustomElement === true);
}

export function isInternalLink(config: SideMenuLinkConfiguration): config is InternalLink {
    if (isCustomLink(config)) {
        return false;
    }
    return (Check.isNullOrUndefined(config.isExternalLink) || config.isExternalLink === false);
}

export function isExternalLink(config: SideMenuLinkConfiguration): config is ExternalLink {
    if (isCustomLink(config)) {
        return false;
    }
    return (!Check.isNullOrUndefined(config.isExternalLink) && config.isExternalLink === true);
}

